import React, { Component } from 'react';
import ServerConnector from 'src/ServerConnector'
import {
    CCard,
    CCardBody,
    CCardGroup,
    CCol,
    CFormLabel,
    CRow
} from '@coreui/react';
import PageHeader from 'src/components/PageHeader';
import { replaceEmpty } from 'src/util/StringUtil';
class ViewSubject extends Component {
    constructor(props) {
        super(props);
        this.state = {
            subject_seq: this.props.page_data.subject_seq,
            inputs: {
                subject_name: "",
                subject_nameerr: "",
                description: "",
                descriptionerr: ""
            }
        };
    }
    componentDidMount() {

        this.props.showPageSpinner(true);

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_SUBJECT_DETAILS",
            "subject_seq": this.state.subject_seq
        }
        connector.postData(dataMap, (data) => { // success

            this.props.showPageSpinner(false);

            let inputs = this.state.inputs;
            inputs["subject_name"] = data.data[0].subject_name;
            inputs["description"] = data.data[0].description;
            this.setState({
                inputs: inputs
            })
        }, (err_cd, msg, data) => { // failure

            this.props.showPageSpinner(false);

            this.props.showAlert("Error", msg, "Ok", null, () => {
                this.props.navigate("manage_subjects")
            })
        })
    }
    render() {
        return (
            <>
                <PageHeader
                    page_name={this.props.page_name}
                    onBackPressed={() => this.props.navigate("manage_subjects")} />
                <CCardGroup>
                    <CCard className="p-4">
                        <CCardBody>
                            <CRow className="row g-3">
                                <CCol md={6}>
                                    <CFormLabel className="viewLabel">Subject Name</CFormLabel>
                                    <div>{replaceEmpty(this.state.inputs.subject_name)}</div>
                                </CCol>
                                <CCol md={6}>
                                    <CFormLabel className="viewLabel">Description</CFormLabel>
                                    <div>{replaceEmpty(this.state.inputs.description)}</div>
                                </CCol>
                            </CRow>
                        </CCardBody>
                    </CCard>
                </CCardGroup>
            </>
        );
    }
}

export default ViewSubject;